module.exports = __webpack_public_path__ + "img/poster_enterprise-ready.55ff7f14.png";